import {Component, OnInit, ViewChild} from '@angular/core';
import {BaseComponent} from "@wms/components";
import {CommonModule} from "@angular/common";
import {FormsModule, NgForm} from "@angular/forms";
import {NotificationService, PrefabService} from "@wms/services";
import {remove, replace, startsWith, reduce, find, isEqual} from "lodash-es";
import {AppEnv, KeyValue, PrefabConfigurationService} from "@wms/settings/prefab-config";
import {Subscription} from "rxjs";
import {runtimeEventManager} from "@wm/core";
import { BasePrefabConfigTab } from '../base-tab-component/base-prefabconfig-tab-component.component';

@Component({
  selector: 'wms-app-environment',
  templateUrl: './app-environment.component.html',
  styleUrls: ['./app-environment.component.less'],
  imports: [
    CommonModule,
    FormsModule
  ],
  standalone: true
})
export class AppEnvironmentComponent extends BasePrefabConfigTab implements OnInit {


  formValueChangesSubscription: Subscription;
  @ViewChild('appEnvForm', {static: true}) override appEnvForm: NgForm;
  private updateAppEnvListener!: Subscription;
  constructor(private prefabService: PrefabService, private notificationService: NotificationService ) {
    super();
    this.getAppEnvProps()
    this.errorKey       = false;
    this.errorValue     = false;
    this.appEnvironment = {
      key     : '',
      value   : ''
    };
    this.updateAppEnvListener = runtimeEventManager.on('update-appenv-profile').subscribe(() => this.updateAppEnvironmentProfile());
  }

  ngOnInit() {
    let setInitialValue: boolean = true;
    if (this.initialAppEnv) {
      setInitialValue = false;
    }
    this.formValueChangesSubscription = this.appEnvForm.form.valueChanges.subscribe(() => {
      if (!this.appEnvForm.form.dirty && setInitialValue) {
        this.initialAppEnv = this.appEnvForm.form.value;
      }
      this.prefabConfigService.isInvalid['appEnv'] = this.appEnvForm.form.invalid;

      if(this.appEnvForm.form.dirty) {
        const initialAppEnvCopy: any = {...this.initialAppEnv},
          formValuesCopy: any = {...this.appEnvForm.form.value};

        delete initialAppEnvCopy['wm-new-input-app-param-key'];
        delete initialAppEnvCopy['wm-new-input-app-param-value'];
        delete formValuesCopy['wm-new-input-app-param-key'];
        delete formValuesCopy['wm-new-input-app-param-value'];

        if (!isEqual(initialAppEnvCopy, formValuesCopy)) {
          this.prefabConfigService.isDirty['appEnv'] = true;
        }
      }
    });
  }

  getAppEnvProps() {
    this.prefabService.getProfile('deployment').then( (props: any) => {
      this.appEnvironmentProps = reduce(props.profileProperty, function (result: AppEnv[], prop: any) {
        if(startsWith(prop.name, 'app.environment.')) {
          result.push({
            name  : prop.name,
            key   : replace(prop.name, 'app.environment.', ''),
            value : prop.value
          });
        }
        return result;
      }, []);
      this.initialAppEnvironmentProps = [...this.appEnvironmentProps];
    });
  }

  editAppEnvironmentProperty(prop: AppEnv) {
    this.prefabConfigService.hideErrorMsg$.next();
    this.prefabConfigService.appEnvModified = true;
  };

  deleteEnvironmentParams(prop: AppEnv) {
    remove(this.appEnvironmentProps, {key: prop.key});
    this.prefabConfigService.isDirty['appEnv'] = true;
    this.prefabConfigService.appEnvModified = true;
  }

  addNewEnvironmentParams() {
    this.errorKey = false;
    this.errorValue = false;
    this.prefabConfigService.hideErrorMsg$.next();
    // validating if key and values are present.
    if (!(this.appEnvironment.key && this.appEnvironment.value)) {
      this.errorKey       = !this.appEnvironment.key;
      this.errorValue     = !this.appEnvironment.value;
      this.prefabConfigService.showErrorMessage(this.locale.MESSAGE_ERROR_NO_PROPERTIES);
      return;
    }
    if (!this.appEnvironmentProps) {
      this.appEnvironmentProps = [];
    }
    // show error if key is duplicate
    if (find(this.appEnvironmentProps, {key: this.appEnvironment.key})) {
      this.prefabConfigService.showErrorMessage(this.locale.MESSAGE_ERROR_DUPLICATE_PROPERTIES);
      return;
    }
    this.appEnvironmentProps.push({
      name  : "app.environment." + this.appEnvironment.key,
      key   : this.appEnvironment.key,
      value : this.appEnvironment.value
    });
    this.prefabConfigService.appEnvModified = true;
    this.appEnvironment.key = this.appEnvironment.value = '';
  }

  updateAppEnvironmentProfile() {
    if(this.prefabConfigService.appEnvModified) {
      this.prefabConfigService.hideErrorMsg$.next();
      let envProfiles = reduce(this.appEnvironmentProps, (result: any, prop: AppEnv) => {
        result[prop.name] = prop.value;
        return result;
      }, {});

      this.prefabService.updateAppProps(envProfiles).then((response: any) => {
        this.prefabConfigService.appEnvModified = false;
      });
    }
  }

  override ngOnDestroy() {
      this.updateAppEnvListener?.unsubscribe();
      this.formValueChangesSubscription?.unsubscribe();
      this.registerDestroyListener.unsubscribe();
  }
}
